import styled from 'styled-components/macro';
import { ButtonProps } from '../types/ButtonProps';

export const IconButton = styled.button.attrs(({ className }) => ({
  className: className
    ? className.indexOf('ww-icon-button') === -1
      ? 'ww-icon-button ' + className
      : className
    : 'ww-icon-button',
}))<ButtonProps>`
  appearance: none;
  border: 1px solid var(--gray-2);
  font-size: 1.077em;
  transition: all 300ms ease-out;
  cursor: pointer;
  text-align: center;
  padding: 0;
  outline: none;
  border-radius: 9999px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.143em;
  height: 2.143em;
  box-sizing: border-box;
  background-color: ${(props) =>
    props.solid
      ? props.primary
        ? 'var(--primary-color)'
        : props.secondary
        ? 'var(--secondary-color)'
        : 'var(--black)'
      : 'transparent'};
  border-color: ${(props) =>
    props.transparentBorder
      ? 'transparent'
      : props.solid
      ? props.primary
        ? 'var(--primary-color)'
        : props.secondary
        ? 'var(--secondary-color)'
        : 'var(--black)'
      : 'var(--gray-3)'};
  color: ${(props) =>
    !props.solid
      ? props.primary
        ? 'var(--primary-color)'
        : props.secondary
        ? 'var(--secondary-color)'
        : 'inherit'
      : 'var(--white)'};

  :hover:not([disabled]) {
    text-decoration: none;
    background-color: ${(props) =>
      props.secondary
        ? 'var(--secondary-color-alt)'
        : 'var(--primary-color-alt)'};
    border-color: ${(props) =>
      props.secondary
        ? 'var(--secondary-color-alt)'
        : 'var(--primary-color-alt)'};
    color: var(--white);
  }

  :focus {
    box-shadow: 0 0 0 2px rgba(200, 200, 200, 0.8);
  }

  &[disabled] {
    opacity: 0.1;
    cursor: default;
  }
`;

export default IconButton;
